module.exports = __webpack_public_path__ + "static/media/startButton.6548f1fa.svg";